import DataSource from './DateSourceContainer';

export default DataSource;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/DataSource/index.js